import { useCurrentUserProfile } from "#imports";
import { ROUTE_ORGANIZATIONS, ROUTE_START_DASHBOARD, ROUTE_MY_DAY, ROUTE_MY_EVENTS } from "~/constants/routes";
import { Role } from "~/enums/role";
import { getOAuthUser } from "~/utils/oauthUserStorage";

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path !== "/") {
    return;
  }

  const user = getOAuthUser();

  if (!user) {
    return;
  }

  if (user.roles.includes(Role.Admin)) {
    return navigateTo(ROUTE_ORGANIZATIONS);
  }

  const { currentUserProfile } = await useCurrentUserProfile();

  if (currentUserProfile?.roles.includes(Role.OrganizationManager)) {
    return navigateTo(ROUTE_START_DASHBOARD);
  }

  if (currentUserProfile?.roles.includes(Role.Physio)) {
    return navigateTo(ROUTE_MY_DAY);
  }

  if (currentUserProfile?.roles.includes(Role.Backoffice)) {
    return navigateTo(ROUTE_START_DASHBOARD);
  }

  if (currentUserProfile?.roles.includes(Role.Secretary)) {
    return navigateTo(ROUTE_MY_EVENTS);
  }

  if (currentUserProfile?.roles.includes(Role.LocationManager)) {
    return navigateTo(ROUTE_START_DASHBOARD);
  }
});
